import GalleryPreview from './GalleryPreview';
import $ from 'jquery';

export default class CoverGalleryPreview extends GalleryPreview {

	/**
	 *
	 */
	constructor(node, index, type) {
		super(node, index, type);
		this.init();
	}

	/**
	 *
	 * @chainable
	 */
	init() {
		// @todo
		var options = this.getOptions()
		options.images = this.node.children('.gallery-preview__cover-image').data('images').split(',');
		options.captionsArray = this.node.children('.gallery-preview__cover-image').data('captions').split('&&');
		this.setOptions(options);
		this.initSlickLightbox(this.getOptions());
		return this;

	}
}
